import React, { useState } from 'react'
import './Modal.scss'
import config from '../config'
import { reactLocalStorage } from 'reactjs-localstorage'
const ConfirmPopup = (props) => {
    console.log("props:::",props)
    const [loading,setLoading]=useState("");
    
    return (
        // <div>
        //     <div className={props.show ? "backdrop" : ""}></div>
        //     <div className="Modal" style={{backgroundColor:props.menuColor}}>
        //         {props.children}
        //         <button className='modalbtn margin' onClick={props.closeModal}>Cancel</button>
        //         <a href="sms:9306;?&amp;body=OK" className='sms-btn msgbtn'>Okay</a>
        //         {/* <button className='modalbtn' onClick={props.handleSubmit}>Okay</button> */}
        //     </div>
        // </div>
        <div className="modal-bg">
        <div className="model-content">    
        <h1 className="text-center bold px-5">
         Are you sure you want to unsubscribe?</h1>
        <button className='modalbtn margin text-white button-bg' onClick={props.setShowConfirmModal} >Cancel</button>
        {props.mode==="sms"?<a href="sms:9306;?&amp;body=OK" className='sms-btn msgbtn button-bg text-white modalbtn'>Okay</a>:<button className='modalbtn margin text-white button-bg' onClick={()=>{
            props.setShowConfirmModal();
            props.handleUnsub()}} >Okay</button>}
        </div>
       </div>
   

    )
}

export default ConfirmPopup;
